module.exports = new __parcel__URL__("Accountmanagement.571239c5.webp").toString();